<!--
    Pojedynczy przycisk wyboru tekstury
-->

<template>
    <button class="TextureButton" @click="changeSceneClick(runScene)" v-if="isShow" :disabled="isActive">
        <div :style="[computedStyle]" class="inner">
            <p>{{ textureName }}</p>
        </div>
    </button>
</template>

<script>
    export default {
        name: 'TextureButton',

        props: {
            scene: String,
            texture: String,
            surfaceId: { type: Number, default: 1 }   // Który sufit, albo sufit czy ściana = który numer z nazwy porównywać 1 lub 2
        },
        data() {
            return {
                serie: "verde",
            }
        },
        computed: {
            isShow: function () {
                let s = this.scene.split("_")
                let t = this.texture.split("_")
                return (s[0] == t[0])
            },
            isActive: function () {
                let s = this.scene.split("_")
                return (s[this.surfaceId] == this.textureId)
            },
            textureId: function () {
                // verde_8 → split[1] → 8
                return this.texture.split("_")[1]
            },
            textureName: function () {
                return this.texture.replace("_", " ")
            },
            srcPath: function () {
                let active = (this.isActive) ? '_active' : '';
                return require('@/assets/icons/icon_' + this.texture + active + '.png')
            },
            computedStyle: function () {
                //return 'url(' + this.srcPath + ')'
                return {
                    'background-image': 'url(' + this.srcPath + ')'
                }
            },
            runScene: function () {
                // verde_17_11 → split → [verde, 17, 11]
                let s = this.scene.split("_")

                // [verde, 17, 11] → s[1] = 8 → [verde, 8, 11]
                s[this.surfaceId] = this.textureId

                // [verde, 8, 11] →  verde_8_11_
                let re = ''
                for (let i = 0; i < s.length; i++) {
                    re += s[i] + '_'
                }
                return re.slice(0, -1)
            }
        },
        beforeUpdate: function () {
            this.serie = this.scene.split("_")[0]
        },
        methods: {
            changeSceneClick: function (val) {
                this.$root.$emit('changeSceneClick', val)
            }
        }
    };
</script>

<style scoped>
    button {
        background: transparent;
        background-size: cover;
        border: none;
        padding: 0;
        outline: none;
        cursor: pointer;
        box-shadow: inset -1px 1px 1px 0px rgba(0,0,0,0.5);
        box-sizing: border-box;
        width: 66px;
        height: 66px;
        transition: all 0.3s ease;
        border-bottom: 0px solid rgba(255,255,255,0);
        opacity: 1;
        margin: 0;
    }

        button:disabled,
        button[disabled] {
            box-shadow: inset 0 0 14px 0px rgba(0, 0, 0, 0.5);
            /*opacity: 0.5;*/
        }

    div.inner {
        position: relative;
        background-size: cover;
        width: 100%;
        height: 100%;
        vertical-align: bottom;
    }

        div.inner p {
            position: relative;
            margin: 0;
            padding-top: 110%;
            color: #434D56;
            vertical-align: middle;
            font-size: 0.9rem;
            text-transform: capitalize;
            text-align: center;
        }

    button:not(:disabled) div.inner:hover {
        transition: all 0.3s ease;
        box-shadow: inset 0 0 14px 0px rgba(0, 0, 0, 0.5);
    }

    .active {
        border-bottom: 8px solid rgba(255,255,255,0.6);
    }
</style>